"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContext = void 0;
var withContext = exports.withContext = {
  '@context': 'https://schema.org'
};